import { useQuery } from "react-query";
import useDepartmentSelector from "../../../TCPForms/hooks/useDepartmentSelector";

const getResidentialData = (id = null) => {
  const tenantId = Digit.ULBService.getStateId() || "up";
  const [, applicationFlow] = useDepartmentSelector();
  if (id) {
    // Fetch application data for edit flow
    const fetchApplicationData = async () => {
      return await Digit.OBPSService.BPASearch(tenantId, { applicationId: id, isEmployee: false });
    };
    const { data, isLoading: isAppDataLoading, isSuccess } = useQuery({ queryKey: [id], queryFn: fetchApplicationData });
    const applicationData = isSuccess && data?.BPA?.[0];
    return { applicationData, isAppDataLoading };
  }
  const applicationData = {
    plotinMelaArea: null,
    ownerName: null,
    careOf: null,
    ownerAddress: null,
    mobileNumber: null,
    aadhaarNumber: null,
    permissionType: null,
    zoneType: null,
    subZoneType: null,
    primaryUse: null,
    activityProposed: null,
    applicationType: "FORM_MAP",
    plotArea: null,
    plotDetails: null,
    district: null,
    planOn: null,
    tehsil: null,
    village: null,
    schemeName: null,
    mohalla: null,
    layoutsanctionNumber: null,
    layoutsanctionDate: null,
    documents: null,
    natureOfConstruction: null,
    landMark: null,
    isRevised: null,
    sectorNoPlotNo: null,
    projectType: null,
    proposalType: null,
    tenantId,
    department: null,
    workflow: { action: "INITIATE", assignes: null },
    landInfo: {
      owners: null,
      address: {
        city: null,
        locality: { code: null },
        region: null,
        doorNo: null,
        areaType: null,
      },
      tenantId,
    },
    businessService: applicationFlow === 'DA' ? 'BPA_MAPSUB_DA' : 'BPA_MAPSUB_AVP',
    selectedOffice: null,
  };

  return { applicationData, isAppDataLoading: false };
};

export default getResidentialData;
